/**
 * Label + control + hint + inline error. `children` is a render function that
 * receives the a11y props to spread onto the control.
 */
export default function FormField({ id, label, optional = false, hint, error, full = false, children }) {
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  const describedBy = [hintId, errorId].filter(Boolean).join(' ') || undefined;

  return (
    <div className={`field${full ? ' field--full' : ''}${error ? ' is-invalid' : ''}`} data-field={id}>
      <label className="field__label" htmlFor={id}>
        {label}
        {optional && <span className="field__opt"> (optional)</span>}
      </label>
      {children({ id, 'aria-invalid': error ? true : undefined, 'aria-describedby': describedBy })}
      {hint && (
        <p className="field__hint" id={hintId}>
          {hint}
        </p>
      )}
      {error && (
        <p className="field__error" id={errorId}>
          {error}
        </p>
      )}
    </div>
  );
}
